import { ThemeColors } from '~/themes/colors'

interface LoadingSpinnerColors {
  color: ThemeColors
  trackColor: ThemeColors
}

export const LoadingSpinnerColors: LoadingSpinnerColors = {
  color: { default: 'gray.500' },
  trackColor: { default: 'gray.800' },
}
